import React from 'react';
import * as S from './GameHero.styles';

/**
 * Reusable Hero Component for game pages and product landing pages.
 * Supports background customization, status badges, title, subtitle, CTAs, and image.
 */
const GameHero = ({
  title,
  subtitle,
  badges = [],
  image,
  imageAlt = '',
  actions = [],
  background,
}) => {
  return (
    <S.HeroContainer $background={background}>
      <S.HeroContent>
        {image && (
          <S.ImageContainer>
            <S.Image src={image} alt={imageAlt || title} loading="eager" />
          </S.ImageContainer>
        )}

        <S.TextContainer>
          {badges.length > 0 && (
            <S.BadgeContainer>
              {badges.map((badge, idx) => (
                <S.Badge key={idx} $variant={badge.variant}>
                  {badge.label}
                </S.Badge>
              ))}
            </S.BadgeContainer>
          )}

          {title && <S.Title>{title}</S.Title>}
          {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}

          {actions.length > 0 && (
            <S.ActionsContainer>
              {actions.map((action, idx) => (
                <S.ActionButton
                  key={idx}
                  href={action.href}
                  onClick={action.onClick}
                  $variant={action.variant || 'primary'}
                  target={action.external ? '_blank' : undefined}
                  rel={action.external ? 'noopener noreferrer' : undefined}
                >
                  {action.icon && <span>{action.icon}</span>}
                  {action.label}
                </S.ActionButton>
              ))}
            </S.ActionsContainer>
          )}
        </S.TextContainer>
      </S.HeroContent>
    </S.HeroContainer>
  );
};

export default GameHero;
